import styled from "styled-components";
import { Box, Button, Typography } from '@mui/material';

export const SelectInspectionWrapper = styled(Box)`
  height: 100%;
  padding-top: 24px;
  padding-inline: 8px;
  display: flex;
  flex-direction: column;
  text-align: start;
  gap: 16px;
`;

export const Title = styled(Typography).attrs({ variant: "h6" })`
  font-weight: 700;
  font-size: 16px;
  color: #00000099;
`;

export const SettingsBox = styled(Box)`
  background-color: #f7f7fe;
  border-radius: 8px;
  padding: 12px;
  width: 100%;
  border: 1px solid #e0e0ff;
  position: relative;
`;

export const SettingsHeader = styled(Box)`
  display: flex;
  margin-bottom: 10px;
`;

export const SettingsTitle = styled(Typography)`
  font-weight: 700;
  font-size: 12px;
  color: #000000;
  text-align: start;
  display: flex;
  align-items: center;
`;

export const SettingsListWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: start;
  margin-inline: 20px;
  width: 100%;
`;

export const SettingsList = styled.ul`
  margin: 0;
  padding: 0 0 0 20px; // Add left padding for bullet points
  display: flex;
  flex-direction: column;
  justify-content: start;
  list-style-position: outside; // Ensure bullets appear outside content
`;

export const SettingsListItem = styled.li`
  font-weight: 400;
  font-size: 10px;
  list-style-type: disc; // Explicitly set bullet style
  margin-left: 8px; // Adjust spacing as needed
  padding-left: 4px; // Space between bullet and text
`;

export const PreviewButton = styled(Button).attrs({ 
  variant: "outlined",
  color: "primary",
  fullWidth: true 
})`
  width: 436px;
  height: 41px;
  border-radius: 8px;
  border-width: 1px;
  gap: 8px;
  padding: 14px 16px;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
`;

export const EmailStatusContainer = styled.div<{ visible: boolean }>`
  width: 100%;
  display: ${props => props.visible ? 'flex' : 'none'};
  flex-direction: column;
  justify-content: center;
  padding-bottom: 16px;
  align-items: center;
  background-color: #F2F0FF;
  border-radius: 12px;
  height: fit-content;
`;

export const StatusIcon = styled.div`
  width: 40px;
  height: 40px;
  margin-top: 16px;
`;

export const StatusMessage = styled.span`
  margin-top: 16px;
  font-size: 16px;
  font-weight: 400;
  color: #435363;
`;